import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// initial state
const state = {
  category: {},
  categories: [],
  search: [],
  totalPages: 0,
}

// getters
const getters = {
  category: (state) => {
    return state.category;
  },
  categories: (state) => {
    return state.categories;
  },
  totalPages: (state) => {
    return state.totalPages;
  },
  search: (state) => {
    return state.search;
  }
}

// mutations
const mutations = {
  SET_CATEGORY(state, category) {
    state.category = category;
  },

  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },

  SET_CATEGORIES_SEARCH(state, categories) {
    state.search = categories;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  ADD_CATEGORY(state, category) {
    state.categories.push(JSON.parse(JSON.stringify(category)));
  },

  UPDATE_CATEGORY(state, category) {
    let categoryIndex = state.categories.findIndex((item) => {
      return item.id == category.id;
    });
    category.total_posts = state.categories[categoryIndex].total_posts;
    Vue.set(state.categories, categoryIndex, JSON.parse(JSON.stringify(category)));
  },

  DELETE_CATEGORY(state, category) {
    let index = state.categories.indexOf(category);
    if (index > -1) {
      state.categories.splice(index, 1);
    }
  },
}

// actions
const actions = {

  getAllCategories ({commit}, page) {
    if(hasPermission('categories_list')){
      const permission = {
        headers: {
          'X-Permission': 'categories_list'
        }
      };
      let product_id = localStorage.getItem("product");
      axios.get('/admin/categories?page=' + page + '&product_id=' + product_id,permission).then((response) => {
        let res = response.data;
        commit('SET_CATEGORIES', res.data);

        let totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
      });
    }
  },

  // =========================================================================

  searchCategories({ commit }, [query, current_cat]) {
    if(current_cat == undefined)
      current_cat = '';
    return axios.get('/categories/search?q=' + query + '&current=' + current_cat + '&admin=1')
      .then((response) => {
        // commit('SET_CATEGORIES_SEARCH', response.data);
        commit('SET_CATEGORIES_SEARCH', response.data.data);
      });
  },

  // =========================================================================

  searchChildCategories({ commit }, {query}) {
    console.log(product_id,123);

    return axios.get('/categories/search-child-categories?q=' + query)
      .then((response) => {
        commit('SET_CATEGORIES_SEARCH', response.data.data);
        // commit('SET_CATEGORIES_SEARCH', response.data);
      });
  },

  // =========================================================================

  getCategory({commit}, slug) {
    
    axios.get('/admin/categories/' + slug +'?product_id=' + localStorage.getItem('product'))
    .then((response) => {
      commit('SET_CATEGORY', response.data.category);
    });
  },

  // =========================================================================

  createCategory ({commit}, category) {
    let moderatorId = null;
    let parent_category_id = null;

    // if (category.moderator != null) {
    //   moderatorId = category.moderator.id;
    // }

    if (category.parent_category != null) {
      parent_category_id = category.parent_category.id;
    }
    if(hasPermission('categories_create')){
      const permission = {
        headers: {
          'X-Permission': 'categories_create'
        }
      };
      return axios.post(`/admin/categories?product_id=${localStorage.getItem('product')}`, {
        title: category.title,
        slug: category.new_slug,
        description: category.description,
        meta_title: category.meta_title ? category.meta_title :"",
        meta_description: category.meta_description ? category.meta_description :"",
        meta_keyword: category.meta_keyword ? category.meta_keyword : "",
        icon: category.icon,


        // moderator: moderatorId,
        parent_id: parent_category_id,
      },permission)
          .then((response) => {
            commit('ADD_CATEGORY', response.data.category);
          });
    }

  },

  // =========================================================================

  updateCategory ({commit}, category) {
    let moderatorId = null;
    let parent_category_id = null;

    // if (category.moderator != null) {
    //   moderatorId = category.moderator.id;
    // }

    if (category.parent_category != null) {
      parent_category_id = category.parent_category.id;
    }
    if(hasPermission('categories_edit')){
      const permission = {
        headers: {
          'X-Permission': 'categories_edit'
        }
      };
      return axios.post('/admin/categories/' + category.id +'?product_id=' + localStorage.getItem('product'), {

        _method: 'PUT',
        id: category.id,
        title: category.title,
        slug: category.new_slug,
        description: category.description,
        meta_title: category.meta_title ? category.meta_title :"",
        meta_description: category.meta_description ? category.meta_description :"",
        meta_keyword: category.meta_keyword ? category.meta_keyword : "",
        icon: category.icon,

        // moderator: moderatorId,
        parent_id: parent_category_id
      },permission)
          .then((response) => {
            commit('UPDATE_CATEGORY', response.data.category);
          });
    }
  },

  // =========================================================================

  deleteCategory({commit}, category) {
    if(hasPermission('categories_delete')){
      const permission = {
        headers: {
          'X-Permission': 'categories_delete'
        }
      };
      return axios.delete('/admin/categories/' + category.slug +'?product_id=' + localStorage.getItem('product'),null,{
        headers: permission.headers,
        '_method': 'DELETE'
      })
          .then((response) => {
            commit('DELETE_CATEGORY', category);
            return response;
          });
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
